var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolio({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2806 5.15104V3.1942C16.2806 2.80496 16.1002 2.43166 15.7791 2.15643C15.458 1.88119 15.0224 1.72656 14.5684 1.72656H9.43164C8.97755 1.72656 8.54205 1.88119 8.22092 2.15643C7.89979 2.43166 7.7194 2.80496 7.7194 3.1942V5.15104M16.2806 5.15104H7.7194M16.2806 5.15104H18.849C20.7402 5.15104 22.2734 6.68423 22.2734 8.57552V12M7.7194 5.15104H5.15104C3.25975 5.15104 1.72656 6.68423 1.72656 8.57552V12M22.2734 12V18.849C22.2734 20.7402 20.7402 22.2734 18.849 22.2734H5.15104C3.25975 22.2734 1.72656 20.7402 1.72656 18.849V12M22.2734 12H18.849M1.72656 12H5.72179M9.14627 12V14.8537C9.14627 15.7994 8.37967 16.566 7.43403 16.566C6.48838 16.566 5.72179 15.7994 5.72179 14.8537V12M9.14627 12H15.4245M9.14627 12H5.72179M18.849 12H15.4245M18.849 12V14.8537C18.849 15.7994 18.0824 16.566 17.1367 16.566C16.1911 16.566 15.4245 15.7994 15.4245 14.8537V12",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.9ce65ed33a377e24da675b8b83360892.svg";
export { ForwardRef as ReactComponent };